/**
 * @generated SignedSource<<04276df08361b22fb635eaa652118763>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTable_nativeIssueTable_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"groupTableBody_nativeIssueTable_project" | "tableBody_nativeIssueTable_project">;
  readonly " $fragmentType": "issueTable_nativeIssueTable_project";
};
export type issueTable_nativeIssueTable_project$key = {
  readonly " $data"?: issueTable_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueTable_nativeIssueTable_project",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "groupTableBody_nativeIssueTable_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "tableBody_nativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "dec27f6377a00d0f180cbce1d4d237be";

export default node;
